module.exports = __webpack_public_path__ + "media/images/a_analitico-6516cd3f.png";